import React, {useState, useCallback, useEffect} from 'react';
import { useDispatch } from 'react-redux';
import { modalActions } from '../../redux/root-action';
import styled from 'styled-components';
import ReactModalContent from '../Shared/Modal/ReactModalContent';
import ReactModalFooter from '../Shared/Modal/ReactModalFooter';
import { modals } from '../../utils/constants';
import {ANALYTICS_IDS} from "../../utils/analyticsTrackingConstants";
import {BeaconModal} from "../Shared/Modal/BeaconModal";
// import {ProfileBeaconCheckbox} from "../Shared/ProfileBeaconComponents";
import ReactModalHeader from "../Shared/Modal/ReactModalHeader";
import {UseAppSelector} from "../../redux/configure-store";
import {getIsActivationCodeLoaded, getMobileNumber, getSelectedPlan} from "../../redux/profile/selectors";
import {getActivationCode, setIsActivationCodeLoaded, setIsAnnualSalaryError} from "../../redux/profile/slice";
import { ProfileBeaconControl } from 'components/Shared/ProfileBeaconComponents';
import { ProfileBeaconControlGroup } from 'components/Shared/ProfileBeaconComponents';

const StyledHeaderText = styled.div`
  font-size: 20px;
  font-family:"Nimbus Sans Novus Bold";
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: 0.02px;
  text-align: left;
  margin-top: 16px;
  @media (max-width: 768px) {
    font-size: 18px;
  }
  @media (max-width: 640px) {
    font-size: 16px;
  }
`;

const StyledCheckboxContainer = styled.div`
  margin-top: 24px;
  display: flex;
  @media (max-width: 640px) {
    margin-top: 32px;
  }
`;

const StyledCheckboxLabel = styled.div`
  font-size: 18px;
  line-height: 1.22;
  letter-spacing: 0.02px;
  margin-left: 12px;
  margin-top: 6px;
  @media (max-width: 768px) {
    font-size: 16px;
  }
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;
const StyledPhoneNumber = styled.div`
  margin-top: 4px;
  font-size: 18px;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;
const StyledLink =  styled.a`
  text-decoration: underline;
  color: #086ea1;
  cursor: pointer;
`;

export const SignUpAgreementModal = ({modalName,handleCloseModal,dispatchOverlayLoad}) => {
    const dispatch = useDispatch();
    const [checked,setChecked]=useState(false);
    const mobileNumber = UseAppSelector(getMobileNumber);
    const isActivationCodeLoaded = UseAppSelector(getIsActivationCodeLoaded);
    const selectedPlan = UseAppSelector(getSelectedPlan);
    const planNumber = selectedPlan.value;

    const getActivationCodeMethod = useCallback(() => {
        dispatch(getActivationCode({mobileNumber,planNumber }));
    },[dispatch]);

    const goToTextMessageAgreement = (event: any) => {
        event.preventDefault();
    }

    useEffect(() => {
        if(isActivationCodeLoaded){
            handleCloseModal();
            dispatch(setIsActivationCodeLoaded(false));
            dispatch(modalActions.showModal(modals.SIGN_UP_ACTIVATION_CODE_MODAL));
        }
    },[isActivationCodeLoaded]);

    useEffect(() => {
        const overlay = "Authentication Modal";
        dispatchOverlayLoad(overlay);
    }, []);

    const getFooter = (checked) => {
        return  <ReactModalFooter
            tertiaryButtonText={"Cancel"}
            primaryButtonText={"Send Activation Code"}
            handleOnClick={() => getActivationCodeMethod()}
            handleCancelClick={handleCloseModal}
            primaryButtonId = {ANALYTICS_IDS.SignUpModalActivationBtn}
            tertiaryButtonId={ANALYTICS_IDS.SignUpModalCancelBtn}
            primaryButtonDisabled={!checked}
        />
    };

    
        const closeThisModal = () => {
            dispatch(modalActions.closeModal());
        }

    return (
        <React.Fragment>

            <BeaconModal id={modalName}
                         footer={getFooter(checked)}
                         onClose={closeThisModal}
                         >
                <ReactModalContent>
                    <ReactModalHeader modalTitle="Sign up for text alerts"/>
                    Accept the Text Message Agreement to receive an activation code for text alerts.
                    <StyledHeaderText>
                        Mobile Number
                    </StyledHeaderText>
                    <StyledPhoneNumber>
                        {mobileNumber}
                    </StyledPhoneNumber>

                    <StyledCheckboxContainer>
                        <ProfileBeaconControlGroup>
                        <ProfileBeaconControl inline>
                          
                           <label slot='label' htmlFor='checkbox-1'> <StyledCheckboxLabel>I agree to receive an activation code in a text message, to receive text messages from T. Rowe Price, including security alerts, and to the terms of the&nbsp;<StyledLink target="_blank"  href="https://www.troweprice.com/personal-investing/help/policies-and-security/text-message-agreement.html">Text Message Agreement</StyledLink>. Message and data rates may apply.</StyledCheckboxLabel></label>
                        
                         <input
                         type='checkbox'
                         id="checkbox-1"
                         value="Test Checkbox"
                         onInput={()=>setChecked(!checked)}
                         alt="Check-Box icon"/>
                        </ProfileBeaconControl>
                        </ProfileBeaconControlGroup>
                        
                    </StyledCheckboxContainer>
                </ReactModalContent>
            </BeaconModal>
        </React.Fragment>
    )
}

